import React from 'react';
import lunalogo from './luna_logo.svg';
// import lunalogovar from './luna_logo_v.svg';

export const Logo = () => {
  return <img src={lunalogo} alt={'logo'} />;
};
